import { type Schema, SchemaType } from "../../core/render/logic/Markdoc/index";

export const paragraph: Schema = {
	render: "p",
	type: SchemaType.block,
};
